export const RESET_USER_PASSWORD = "RESET_USER_PASSWORD"

export const CHECK_NOT_AUTHENTICATED = "CHECK_NOT_AUTHENTICATED"

export const CHANGE_LOAN_STATUS = "CHANGE_LOAN_STATUS"

export const RESUBMIT_LOAN_ACTION = "RESUBMIT_LOAN_ACTION"

export const ASSIGN_LOAN_TO_USER_ACTION = "ASSIGN_LOAN_TO_USER_ACTION"

export const ASSIGN_LOAN_RESULT = "ASSIGN_LOAN_RESULT"

export const BATCHES_IMPORT = "BATCHES_IMPORT"

export const VALIDATE_VERIF_CODE = "VALIDATE_VERIF_CODE"

export const VERIF_CODE_RESET = "VERIF_CODE_RESET"

export const LOAD_LOAN_DETAILS_ACTION = "LOAD_LOAN_DETAILS_ACTION"

export const LOAD_LOAN_DETAILS_RESULT = "LOAD_LOAN_DETAILS_RESULT"

export const RESUBMIT_LOAN_RESULT = "RESUBMIT_LOAN_RESULT"

export const GET_CUSTOMER_LOANS_ACTION = "GET_CUSTOMER_LOANS_ACTION"

export const RESET_CUSTOMER_LOANS_ACTION = "RESET_CUSTOMER_LOANS_ACTION"

export const LOAD_ALL_DETAILS_ACTION = "LOAD_ALL_DETAILS_ACTION"

export const GET_BUSINESS_LOANS_ACTION = "GET_BUSINESS_LOANS_ACTION"

export const RESET_BUSINESS_LOANS_ACTION = "RESET_BUSINESS_LOANS_ACTION"

export const UPDATE_LOAN_GROUP_ACTION = "UPDATE_LOAN_GROUP_ACTION"

export const UPDATE_LOAN_GROUP_RESULT = "UPDATE_LOAN_GROUP_RESULT"



// WEBPACK FOOTER //
// ./src/redux/actions/types.js